import { Injectable } from '@angular/core';
import { AuthResponse } from '../models/auth-response.model';
import { Router } from '@angular/router';
import { LocalStorageService } from './storage.service';
import { ApiService } from './api.service';
import { CookieService } from 'ngx-cookie';
import { BehaviorSubject } from 'rxjs';
import { Account } from 'src/models/account.model';
@Injectable({
  providedIn: 'root',
})
export class AuthenticateService {
    private _isLoggedIn = new BehaviorSubject<boolean>(false);
    public isLoggedIn = this._isLoggedIn.asObservable();
    public currentUser = new BehaviorSubject<Account | undefined>(undefined);

  constructor(
    private api: ApiService,
    private localStorage: LocalStorageService,
    private cookieService: CookieService,
    private router: Router,
  ) {}

  //need to get account info to display usernmae

    async authenticate(emailAddress: string, password: string) {
        const token = await this.api.post<AuthResponse>(`${this.api.endpoints.authenticate}/token`, { emailAddress, password }, false);
        if (token) {
            this.setToken(token);
            this._isLoggedIn.next(true);
        }
        return token;
    }

    async setToken(token: AuthResponse) {
      console.log(token);
        await this.localStorage.setObj(this.localStorage.keys.token, token);
    }

    async getToken() {
        return this.localStorage.getEntity<AuthResponse>(this.localStorage.keys.token);
    }

    async logout() {
        const promise = this.api.post(
            this.api.endpoints.authenticate + '/revokeToken', null
        ).catch(() => { });

        this.localStorage.purge();
        this.router.navigate(['auth/login'], { replaceUrl: true, queryParamsHandling: 'preserve' });
        await promise;
        this.cookieService.remove('nextgen-token');
    }

  async getSecretaries() {
    return await this.api.get<any[]>(
      `${this.api.endpoints.search}/secretaries`,
    );
  }

    async hasCookieOrToken() {
        var cookie = this.cookieService.get('nextgen-token');
        if (cookie) {
            const token = await this.localStorage.setItem(this.localStorage.keys.token, cookie);
            this._isLoggedIn.next(true);
        } else {
            const token = await this.getToken();
            console.log(encodeURIComponent(JSON.stringify(token)));
            this._isLoggedIn.next(!!token);
        }
    }

    async isStaff() {
      const token = await this.getToken();
      return token?.roles.filter(x => x.roleId >= 2).length > 0;
    }

    async isStaffAdmin() {
      const token = await this.getToken();
      return token?.roles.filter(x => x.roleId >= 4).length > 0;
    }
    
    async isNgAdmin() {
      const token = await this.getToken();
      return token?.roles.filter(x => x.roleId >= 6).length > 0;
    }
}
